/**
 * @module app.cd
 */

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { apiCall } from 'app/shared/lib/api/api';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { CaseService } from 'app/cm/services/case-service';
import * as CM from 'app/cm/models/essette-api';

@autoinject()
export class MemberProviderRelationshipsPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected caseId: string | null = null;
    protected case: CM.Case | null = null;
    protected memberId?: string | null = null;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly caseService: CaseService,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    protected async activate(params: { caseId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.caseId) {
            throw new Error('Missing required parameters: memberId');
        }

        this.caseId = params.caseId;

        await this.reload();

        if(this.memberId && routeConfig?.navModel) {
            const title = this.i18n.tr('cm:routes.memberProviderRelationships.$title');
            routeConfig.navModel.setTitle(title);
        }
    }


    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        if(this.caseId) {
            await this.loadCase(this.caseId);
        }
    }

    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadCase(caseId: string): Promise<void> {
        if(!caseId) return;

        try {
            this.state.beginLoad();

            const response = await this.caseService.loadCase(caseId);
            this.case = response.results[0];
            this.memberId = this.case?.member?.id;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
